import { PropsWithChildren } from 'react';

interface AutocompleteIndicatorProps extends PropsWithChildren {
  indicator: string;
}

export const AutocompleteIndicator = ({
  children,
  indicator,
}: AutocompleteIndicatorProps) => (
  <div className="flex gap-1">
    {children}
    <span className="text-muted-foreground font-normal lowercase">
      ({indicator})
    </span>
  </div>
);
